export const price = (value = 0) => parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

// export const discountPrice = value => (value > 0 ? `(-${price(value)})` : '0.00')

export const numberComma = value => parseInt((value || 0), 10).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const negativeToZero = value => (value < 0 ? 0 : value)

export const toCurrency = (value = 0) => parseFloat(value).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const floatComma = (value = 0) => parseFloat(parseFloat(value).toFixed(2)).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

export const toCurrencyB = (value = 0) => {
  const numValue = parseFloat(value)
  if (numValue < 0) {
    return `-฿${Math.abs(numValue).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
  }
  return `฿${numValue.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}